jQuery(document).ready(function () {
    if (jQuery("body").attr("id") !== "interactive-size-chart") {
      const sizeInfo = jQuery(".size-info");
      const sizes = JSON.parse(localStorage.getItem("mySizes"));
      if (!sizes) return;
      if (sizes.topSize) {
        sizeInfo.show();
        sizeInfo
          .find('[type="top"]')
          .show()
          .find("b")
          .text(sizes.topSize.replace("size-", ""));
      }
  
      if (sizes.bottomSize) {
        sizeInfo.show();
        sizeInfo
          .find('[type="bottom"]')
          .show()
          .find("b")
          .text(sizes.bottomSize.replace("size-", ""));
      }
  
      if (sizes.onesiesSize) {
        sizeInfo.show();
        sizeInfo
          .find('[type="onesies"]')
          .show()
          .find("b")
          .text(sizes.onesiesSize.replace("size-", ""));
      }
    }
  });
